import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { colorPropType } from '../../Utils/PropTypesValidators';

import Dot from './Dot';
import styles from './Pagination.Styles';

const pagination = ({ numberOfDots, activeDotIndex, containerStyle, ...props }) => {
  return (
    <View
      style={[styles.dotsContainerStyle, containerStyle]}
      testID={FoundationTestKeys.pagination}
    >
      {_renderDots(numberOfDots, activeDotIndex, props)}
    </View>
  );
};

const _renderDots = (numberOfDots, activeDotIndex, props) => {
  const dots = [];
  const {
    activeColor,
    inactiveColor,
    inactiveOpacity,
    size,
    dotSpacing,
    dotStyle,
    ...additionalProps
  } = props;

  const primarySize = size;
  const secondarySize = size / 1.5;
  const tertiarySize = size / 3;

  for (let i = 0; i < numberOfDots; i++) {
    let appropiateSize = primarySize;

    if (
      (activeDotIndex > 2 && (i === activeDotIndex - 3 || i === activeDotIndex + 1)) ||
      (activeDotIndex <= 2 && i === 3)
    ) {
      appropiateSize = secondarySize;
    } else if (
      (activeDotIndex > 2 && (i === activeDotIndex - 4 || i === activeDotIndex + 2)) ||
      (activeDotIndex <= 2 && i === 4)
    ) {
      appropiateSize = tertiarySize;
    }

    if (
      (activeDotIndex <= 2 && i >= 5) ||
      (activeDotIndex > 2 && (i < activeDotIndex - 4 || i > activeDotIndex + 2))
    ) {
      continue;
    }

    dots.push(
      <Dot
        key={i}
        active={i === activeDotIndex}
        activeColor={activeColor}
        inactiveColor={inactiveColor}
        inactiveOpacity={inactiveOpacity}
        size={appropiateSize}
        activeSize={appropiateSize}
        dotSpacing={dotSpacing}
        dotStyle={dotStyle}
        {...additionalProps}
        testID={FoundationTestKeys.paginationDot}
      />,
    );
  }

  return dots;
};

pagination.defaultProps = {
  size: 6,
};

pagination.propTypes = {
  numberOfDots: PropTypes.number.isRequired,
  activeDotIndex: PropTypes.number.isRequired,
  containerStyle: ViewPropTypes.style,
  color: colorPropType,
  inactiveOpacity: PropTypes.number,
  size: PropTypes.number,
  dotSpacing: PropTypes.number,
  dotStyle: ViewPropTypes.style,
};

export default pagination;
